import { isNativeMobile } from '../mobile/capacitor'

export const nativeWelcomeV2 = import.meta.env.VITE_NATIVE_WELCOME_V2 !== 'false'

export function getNativeWelcomePreviewPlatform(): 'android' | 'ios' | null {
  if (!import.meta.env.DEV || typeof window === 'undefined') return null

  const platform = new URLSearchParams(window.location.search).get('nativeWelcomePreview')
  return platform === 'android' || platform === 'ios' ? platform : null
}

export function shouldUseNativeWelcome() {
  return nativeWelcomeV2 && (isNativeMobile() || Boolean(getNativeWelcomePreviewPlatform()))
}

export function isNativeWelcomeEntryPath(pathname: string) {
  return pathname === '/'
}
